import {
  OPEN_OLD_MODAL,
  CLOSE_OLD_MODAL,
  STOP_LOADER,
  START_LOADER,
  modalThunkAction,
  openOldModalActionType,
  closeOldModalActionType,
  stopLoaderActionType,
  startLoaderActionType,
  SET_UNMOUNT_MODAL_CALLBACK,
  setUnmountCallBackActionType,
} from './modalActionTypes';
import { MODAL_NAMESPACE } from './modalReducer';
import { ModalComponentEnum, ModalPosition } from './modalTypes';

export function setUnmountCallBackAction(
  callBack?: () => void
): setUnmountCallBackActionType {
  return {
    type: SET_UNMOUNT_MODAL_CALLBACK,
    payload: callBack,
  };
}

//TODO refactor position data callbacks to config
export function openOldModalAction(
  component: ModalComponentEnum,
  config?: {
    position?: ModalPosition;
    isFullSizeOnMobile?: boolean;
    data?: any;
    callBack?: (data?: any) => void;
    cancelCallback?: (data?: any) => void;
  },
  data?: any,
  callback?: (data?: any) => void,
  cancelCallback?: (data?: any) => void
): openOldModalActionType {
  return {
    type: OPEN_OLD_MODAL,
    payload: {
      component,
      position: config?.position,
      isFullSizeOnMobile: config?.isFullSizeOnMobile,
      data: data || config?.data,
      callback: callback || config?.callBack,
      cancelCallback: cancelCallback || config?.cancelCallback,
    },
  };
}

export function closeOldModalAction(): closeOldModalActionType {
  return {
    type: CLOSE_OLD_MODAL,
  };
}

export function startLoaderAction(): startLoaderActionType {
  return {
    type: START_LOADER,
  };
}

export function stopLoaderAction(): stopLoaderActionType {
  return {
    type: STOP_LOADER,
  };
}

export function startLoaderThunk(): modalThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderAction());
  };
}

export function stopLoaderThunk(): modalThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(stopLoaderAction());
  };
}

export function onModalUnmountCallbackThunk(): modalThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const modalState = getState()[MODAL_NAMESPACE];
    if (modalState.onModalUnmountCallBack) {
      modalState.onModalUnmountCallBack();
      dispatch(setUnmountCallBackAction());
    }
  };
}
